export class User {
    id = 0;
    filteredRoles = [];
    name = '';
    roles = [];
    role = '';
    abbreviation = '';
    avatar_urls = {};
    email = '';
    username = '';
    password = '';
    activeCount = 0;
    overdueCount = 0;
    localId = 0;
    limited = [];

    constructor(user: object) {
        for(var prop in user) {
            if( this.hasOwnProperty(prop) ) {
                this[prop] = user[prop];
            }
        }
    }
    getName() {
        return this.name;
    }
    getId() {
        return this.id;
    }
    getRole() {
        return this.role;
    }
    userCan(role) {
        // TODO: add reverse degredation
        return this.roles.indexOf(role) !== -1;
    }
}


// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/shared/user.model.ts